import React, { Component } from 'react';
import './bootstrap-icons/font/bootstrap-icons.css';
import './card.css';

class Card extends Component {
    constructor(props) {
        super(props);
        this.changeLike = this.changeLike.bind(this);
        this.changeBookmark = this.changeBookmark.bind(this);
        this.state = {
            img: props.img,
            publisher: props.publisher,
            title: props.title,
            description: props.description,
            link: props.link,
            audio_link: props.audio_link,
            isLiked: false,
            likeColor: "inherit",
            isBookmarked: false,
            bookmarkColor: "inheri"
        }
    }

    changeBookmark() {
        this.setState({
            isBookmarked: !this.state.isBookmarked
        }, () => {
            if (this.state.isBookmarked) {
                this.setState({
                    bookmarkColor: "red"
                })
            } else {
                this.setState({
                    bookmarkColor: "inherit"
                })
            }
        })
    }

    changeLike = () => {
        this.setState({
            isLiked: !this.state.isLiked
        }, () => {
            if (this.state.isLiked) {
                this.setState({
                    likeColor: "red"
                })
            } else {
                this.setState({
                    likeColor: "inherit"
                })
            }
        })
    }

    render() {
        return (
            <div className="card-wrapper">
                <div className="card">
                    <div className="card-image">
                        <a href={this.state.link} target="_blank" rel="noopener noreferrer">
                            <img src={this.state.img} alt="thumbnail" className="image" title={this.state.title} />
                        </a>
                    </div>
                    <div className="small">
                        <div className="card-text">
                            <div className="publisher">{this.state.publisher}</div>
                            <div className="title line-clamp-title">{this.state.title}</div>
                            <div className="description line-clamp-description" title={this.state.description}>{this.state.description}</div>
                        </div>
                        <div className="card-stats">
                            <i className="bi bi-heart-fill" title="Like" onClick={this.changeLike} style={{ color: this.state.likeColor }}></i>
                            <a href={this.state.audio_link} target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-headphones" title="Start Listening"></i>
                            </a>
                            <i className="bi bi-bookmark-check" title="Bookmark" onClick={this.changeBookmark} style={{ color: this.state.bookmarkColor }}></i>
                            <a href={this.state.link} target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-box-arrow-up-right" title="Visit Publisher"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default Card;